export default {
  widgets: {
    profileSettings: {
      title: 'Настройки',
      logout: 'Выйти из аккаунта',
      lang: 'Язык',
      ru: 'Русский',
      uz: 'O’zbekcha',
      toggleLabel: 'Тёмная тема',
    },
  },
};
